<template>
  <Modal v-model="show" :width="700" :mask-closable="false"  @on-ok="ok" :loading="loading">
    <div slot="header" class="modal-header">批量配置活动标签</div>
     <Form
			class="repeatForm"
			:ref="'form'+index"
			:rules="ruleValidate"
			:label-width="110"
      v-for="(itemP,index) in labelEntities"
			:key="'index2'+index"
			:model="itemP"
			>
      <Row >
				<Col span="10">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="itemP.labelName" placeholder="请输入标签名称"></Input>
					</FormItem>
				</Col>
				<Col span="10">
					<FormItem prop="labelOrder" label="显示顺序">
						<Input v-model="itemP.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
     </Form>
     <Row>
			<Col span="4">
				<a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 继续添加</a>
			</Col>
		</Row>
  </Modal>
</template>

<script>
import {saveOrEdit} from 'api/labelmanage'
export default {
  name:'SetLabels',
  props:{
    n:{
      type:Number,
      default:0
    },
    selection:{
      type: Array,
      default(){
        return []
      }
    }
  },
  data(){
    const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
    return{
      show: false,
      loading: true,
      labelEntities: [],
      ruleValidate:{
        labelName:[
          { required: true, message: '请输入标签名', trigger: 'blur',type:'string'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
				],
			},
    }
  },
  watch:{
    n(){
      if(this.$refs['form0']){
        this.$refs['form0'][0].resetFields()
      }
      console.log(this.selection)
      this.labelEntities =[
        {
					labelType:5,
          labelName:'',
          labelOrder:'',
          labelSecondaryType:7,
        }
      ]
      this.show = true
    }
  },
  methods:{
    addItem(){
      this.labelEntities.push(
        {
          labelName:'',
          labelOrder:'',
          labelType:5,
          labelSecondaryType:7,
        }
      )
    },
    ok(){
      let validate = true
      for (const i in this.$refs) {
        if(this.$refs[i] instanceof Array){
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
      }
      if (!validate) {
        this.changeLoading()
        return
      }
      const stockFids = []
      this.selection.forEach( ele => {
        stockFids.push( ele.fid )
      })
      console.log(this.stockFids)
      const params = {
        applyType:4,
        labelEntities:this.labelEntities,
        stockFids:stockFids,
      }
      saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('refresh')
					this.$Message.success('保存成功')
				}
			})
			.catch(()=>{
				return
			})
			.finally(()=>{
				this.show = false;
			})
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
  }
}
</script>

<style scoped>
.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
</style>